<template>
  <div>
    <el-button @click="dialogVisible = true">设置中签号</el-button>
    <el-dialog
      :visible="dialogVisible"
      title="设置中签号"
      width="1000px"
      @close="closeDialog"
    >
      <el-form ref="form" label-width="140px">
        <el-form-item label="设置中签号">
          <el-input v-model="ballotNum"></el-input>
        </el-form-item>
        <el-form-item label="五折抢购项目ID">
          <el-input v-model="purchaseId"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="doSave">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  name: 'discountSetgit',
  data() {
    return {
      dialogVisible: false,
      ballotNum: '',
      purchaseId: ''
    };
  },
  components: {},
  computed: {},
  methods: {
    ...mapActions('discountrecord', ['confirmGitNum']),
    closeDialog() {
      this.dialogVisible = false;
      this.$refs['form'].resetFields();
    },
    doSave() {
      this.confirmGitNum({
        ballotNum: this.ballotNum,
        purchaseId: this.purchaseId
      }).then(() => {
        this.$message({
          message: '添加成功！',
          type: 'success'
        });
        this.dialogVisible = false;
        this.$emit('refresh', {
          page: 1
        });
      });
    }
  },
  mounted() {
    this.purchaseId = this.$route.params.purchaseId;
  }
};
</script>
<style lang="less"></style>
